module.exports = __webpack_public_path__ + "static/media/ER-MXC1_1xNMfshzZmjtgj8Nqf1nQQ6SkMRjAsySy.5ed5baac.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/ER-MXC1_1xNMfshzZmjtgj8Nqf1nQQ6SkMRjAsySy
// module id = 637
// module chunks = 0